import React, { ChangeEvent } from 'react';
import {
  GadgetFormInner,
  GadgetFormWrapper,
} from '../V5GadgetForm/V5GadgetForm';
import { Section } from '../MyAccount/Profile/styles';
import Typography from 'kingpin/atoms/Typography';
import Inputs from '../Inputs';

const RemindersGadgetForm = ({
  // Base
  name,
  onNameChanged,
  description,
  onDescriptionChanged,
  // Reminders
  eventOptions,
  // Misc
  isValid,
  isLoading,
  draftGadget,
  selectedEventLabels,
}: {
  // Base
  name: string;
  onNameChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  description: string;
  onDescriptionChanged: (event: ChangeEvent<HTMLInputElement>) => void;
  // Gauge
  eventOptions: DropdownOption[];
  // Misc
  isValid: boolean;
  isLoading: boolean;
  draftGadget?: VisualisationDefinitions.Reminders;
  selectedEventLabels: string;
}) => (
  <GadgetFormWrapper>
    <GadgetFormInner isGadgetBuilder={false}>
      <Section>
        <Typography.Header type="H4">Reminders</Typography.Header>
      </Section>
      {/* Base */}
      <Section>
        <Typography.Body type="Label">Name</Typography.Body>
        <Inputs.TextInput
          placeholder="Name"
          value={name}
          onChange={onNameChanged}
          data-testid={'reminders-name'}
        />
      </Section>
      <Section>
        <Typography.Body type="Label">Description</Typography.Body>
        <Inputs.TextInput
          placeholder="Description"
          value={description}
          onChange={onDescriptionChanged}
        />
      </Section>
      {/* Gauge */}
      <Section>
        <Typography.Body type="Label">Events</Typography.Body>
        <Inputs.Dropdown
          isMulti
          options={eventOptions}
          selectedLabel={selectedEventLabels}
          testId={'reminders-events'}
        />
      </Section>
    </GadgetFormInner>
  </GadgetFormWrapper>
);

export default RemindersGadgetForm;
